import { assertSafePartnerSlug } from "../../supabase/functions/_shared/partner-slug.js";

export {
  PARTNER_SLUG_PATTERN,
  PARTNER_SLUG_MAX_LENGTH,
  RESERVED_PARTNER_SLUGS,
  normalizePartnerSlug,
  isSafePartnerSlug,
  assertSafePartnerSlug,
} from "../../supabase/functions/_shared/partner-slug.js";

export const buildPartnerSubdomainUrl = ({
  slug,
  partnerDomain = "procertcompliance.com",
  path = "/dashboard",
  protocol = "https:",
}) => {
  const cleanSlug = assertSafePartnerSlug(slug);

  const cleanDomain = String(partnerDomain || "procertcompliance.com").trim();
  const normalizedProtocol = String(protocol || "https:").endsWith(":")
    ? String(protocol || "https:")
    : `${protocol}:`;
  const normalizedPath = String(path || "/dashboard").startsWith("/")
    ? String(path || "/dashboard")
    : `/${path}`;

  return `${normalizedProtocol}//${cleanSlug}.${cleanDomain}${normalizedPath}`;
};

export const appendSessionHash = (targetUrl, session) => {
  if (!session?.access_token || !session?.refresh_token) {
    return targetUrl;
  }

  const params = new URLSearchParams({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });

  return `${String(targetUrl).split("#")[0]}#${params.toString()}`;
};

export const isTrustedAuthHandoffTarget = (
  targetUrl,
  partnerDomain = "procertcompliance.com",
) => {
  if (typeof window === "undefined") return false;

  try {
    const target = new URL(targetUrl, window.location.origin);
    if (target.origin === window.location.origin) return true;

    const cleanDomain = String(partnerDomain || "procertcompliance.com")
      .trim()
      .toLowerCase();

    return (
      target.protocol === "https:" &&
      !target.port &&
      target.hostname.toLowerCase().endsWith(`.${cleanDomain}`)
    );
  } catch {
    return false;
  }
};

export const IMPERSONATION_HANDOFF_BLOCKED = "IMPERSONATION_HANDOFF_BLOCKED";

// An impersonation session lives in this tab's sessionStorage only. Handing
// its tokens to another origin (a partner subdomain) would store them in that
// origin's localStorage, where they outlive the tab, show no impersonation
// banner and replace any session the administrator has there.
export const assertHandoffAllowed = ({
  targetUrl,
  currentOrigin,
  impersonating,
}) => {
  if (!impersonating) return;
  const target = new URL(targetUrl, currentOrigin);
  if (target.origin === currentOrigin) return;
  throw Object.assign(
    new Error(
      "Other sites can't be opened from an impersonation session. End the session and sign in as yourself.",
    ),
    { code: IMPERSONATION_HANDOFF_BLOCKED },
  );
};
